import { Download, CreditCard } from "lucide-react";

const PaymentManagementHeader = () => {
  return (
    <div className="flex flex-col justify-between gap-4 md:flex-row md:items-center">
      {/* Left Section */}
      <div>
        <h1 className="font-display text-2xl font-bold text-secondary md:text-3xl">
          NPS Payment Management
        </h1>
        <p className="mt-1 text-muted-foreground">
          Track contributions, process payments, and manage settlements
        </p>
      </div>

      {/* Right Section */}
      <div className="flex gap-3">
        {/* Export Report Button */}
        <button className="inline-flex h-10 items-center justify-center gap-2 whitespace-nowrap rounded-xl border border-border bg-transparent px-5 py-2 text-sm font-semibold text-foreground ring-offset-background transition-all duration-200 hover:border-border/80 hover:bg-muted/50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50">
          <Download className="h-4 w-4" />
          Export Report
        </button>

        {/* Record Payment Button */}
        <button className="inline-flex h-10 items-center justify-center gap-2 whitespace-nowrap rounded-xl bg-primary px-5 py-2 text-sm font-semibold text-primary-foreground shadow-sm ring-offset-background transition-all duration-200 hover:bg-primary/90 hover:shadow-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50">
          <CreditCard className="h-4 w-4" />
          Record Payment
        </button>
      </div>
    </div>
  );
};

export default PaymentManagementHeader;
